import React from 'react';
import './WhyChooseUs.css';

import { whyChooseUs } from '../../../constants';
import { Heading } from '../../../components';



const WhyChooseUs = () => {

  const { sub, heading, content, points } = whyChooseUs;

  return (
    <section className="whyChooseUs">

      {/* Content Container */}
      <div className="box-container">

        <div className='content'>
          <div className='text'>

            {/* Section Heading */}
            <Heading title={heading} subTitle={sub} linear sideHeading />

            {/* Paragraph */}
            <p>{content}</p>

            {/* Why Choose Us Points */}
            <div className="whyUs-points">
              {points.map((item) => (
                <li key={item.id}>
                  <div className='icon'>{item.icon}</div> {/* Feature Icon */}
                  <div className='text'>
                    <h5>{item.title}</h5> {/* Feature Title */}
                    <p>{item.content}</p> {/* Feature Content */}
                  </div>
                </li>
              ))}
            </div>

          </div>
        </div>

      </div>

    </section>
  );
};

export default WhyChooseUs;